var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as SlideFactory from "../../classes/definitions/slide/slide";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import SlidesList from '../../components/Slides/SlidesList/SlidesList';
import AppRoutes from '../../config/appRoutes';
import SlidesReduxProps from "./SlidesReduxProps";
var Slides = /** @class */ (function (_super) {
    __extends(Slides, _super);
    function Slides() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.brandId = '';
        _this.categoryId = '';
        _this.staticPageId = '-1';
        _this.state = {
            data: [],
            meta: null
        };
        _this.getAllSlidesAction = function () {
            if (_this.staticPageId !== "-1") {
                return _this.api.getStaticPageSlides(_this.brandId, _this.staticPageId);
            }
            if (_this.categoryId !== "-1") {
                return _this.api.getCategorySlides(_this.categoryId);
            }
            if (_this.brandId !== "-1") {
                return _this.api.getBrandSlides(_this.brandId);
            }
            return _this.api.getSlides();
        };
        _this.getAllSlides = function () {
            var actionMethod = _this.getAllSlidesAction();
            actionMethod
                .then(function (response) {
                var slides = SlideFactory.createSlides(response.data);
                _this.setState({ data: slides });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка с слайдове', _this.props.history);
            });
        };
        _this.toNewSlide = function () {
            if (_this.staticPageId !== "-1") {
                _this.props.history.push(AppRoutes.brand.path + "/" + _this.brandId + AppRoutes.staticPage.path + "/" + _this.staticPageId + AppRoutes.staticPageSlide.path);
            }
            else if (_this.categoryId !== "-1") {
                _this.props.history.push(AppRoutes.category.path + "/" + _this.categoryId + AppRoutes.categorySlide.path);
            }
            else if (_this.brandId !== '-1') {
                _this.props.history.push(AppRoutes.brand.path + '/' + _this.brandId + AppRoutes.brandSlide.path);
            }
            else {
                _this.props.history.push(AppRoutes.slide.path);
            }
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        _this.toParentProduct = function () {
            if (_this.brandId !== "-1") {
                _this.props.history.push(AppRoutes.brand.path + '/' + _this.brandId);
            }
            else if (_this.categoryId !== "-1") {
                _this.props.history.push(AppRoutes.category.path + '/' + _this.categoryId);
            }
        };
        return _this;
    }
    Slides.prototype.componentDidMount = function () {
        this.brandId = _.get(this.props, 'match.params.brandId', '-1');
        this.categoryId = _.get(this.props, 'match.params.categoryId', '-1');
        this.staticPageId = _.get(this.props, 'match.params.staticPageId', '-1');
        this.getAllSlides();
    };
    Slides.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u0421\u043B\u0430\u0439\u0434\u043E\u0432\u0435"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewSlide, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432 \u0441\u043B\u0430\u0439\u0434"),
                            React.createElement("a", { onClick: this.toParentProduct },
                                React.createElement("i", { className: "fa fa-backward" }),
                                " \u041D\u0430\u0437\u0430\u0434")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(SlidesList, { gridData: data, messages: this.messages, deleteItem: this.deleteItem, brandId: this.brandId, categoryId: this.categoryId, staticPageId: this.staticPageId }))))));
    };
    return Slides;
}(React.Component));
export default connect(null, SlidesReduxProps.mapDispatchToProps)(Slides);



//////////////////
// WEBPACK FOOTER
// ./src/views/Slides/Slides.tsx
// module id = 133
// module chunks = 0